<template>
  <div class="relative flex items-start gap-2">
    <form-input
      class="min-w-0 flex-1"
      type="text"
      :modelValue="modelValue"
      :placeholder="placeholder"
      autocomplete="off"
      spellcheck="false"
      @update:modelValue="emitValue" />

    <form-button
      icon="media/icons/hass_export.png"
      color="secondary"
      class="flex-shrink-0"
      title="Browse Home Assistant entities"
      aria-label="Browse Home Assistant entities"
      @click="showPicker = true" />

    <HomeAssistantEntities
      v-if="showPicker"
      :show="showPicker"
      :settings="settings"
      :domain="domain"
      :selected="modelValue"
      @confirm="onEntitySelected"
      @close="showPicker = false"
      @cancel="showPicker = false" />

    <p v-if="invalidSyntax" class="absolute left-0 top-full z-10 mt-1 text-xs text-red-400">
      Use the format <code>domain.entity</code>.
    </p>
  </div>
</template>

<script setup>
import HomeAssistantEntities from './HomeAssistantEntities.vue';
import { computed, ref } from 'vue';

const props = defineProps({
    modelValue:  { type: String,  default: '' },
    settings:    { type: Object,  required: true },
    placeholder: { type: String,  default: 'entity.id' },
    domain:      { type: String,  default: '' },
});

const emit = defineEmits(['update:modelValue']);
const showPicker = ref(false);

const invalidSyntax = computed(() => {
    const value = String(props.modelValue ?? '');
    return value.length > 0 && !/^[a-z0-9_]+\.[a-z0-9_]+$/.test(value);
});

function emitValue(value) {
    // Do not trim or normalize: manually entered entity IDs must round-trip
    // exactly, including values that are not currently known to Home Assistant.
    emit('update:modelValue', value);
}

function onEntitySelected(entityId) {
    emit('update:modelValue', entityId);
    showPicker.value = false;
}
</script>
